import AccumActOverlay from '../account-overlay/account-overlay.vue';

export default {
  name: 'accumulation-account',
  components: {
    AccumActOverlay,
  },
  props: {
    accumNotReq: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    getItem() {
      return this.$store.getters['toolkit/getItemData'];
    },
    status() {
      return this.getItem.accumulation.status;
    },
    isTransition() {
      return this.getItem.requirements.eligibility.reasons === 'The pension will be a transition to retirement pension';
    },
    total() {
      return this.getItem.accumulation.amount;
    },
    unrestricted() {
      return this.getItem.accumulation.unrestrictedNonPreserve;
    },
    taxable() {
      return this.getItem.accumulation.components.taxable.value;
    },
    nonTaxablePercent() {
      return this.getItem.accumulation.components.nonTaxable.percent;
    },
    nonTaxable() {
      return this.getItem.accumulation.components.nonTaxable.value;
    },
    menuActions() {
      return ['Edit'];
    },
    fundName() {
      return this.$store.getters['fund/getFund'].details.name;
    },
  },
  methods: {
    handleMenuAction(action) {
      switch (action) {
        case 'Start':
          this.$emit('action', 'start');
          break;
        case 'Edit':
          this.$emit('action', 'edit');
          break;
        default:
          console.warn('ACCUMULATION_ACCOUNT::Unknown accumulation action', action);
      }
    },
  },
};
